import React, { createContext, useContext, useState } from 'react';

const AdminPropertiesListContext = createContext();

export const AdminPropertiesListProvider = ({ children }) => {

    const [message, setMessage] = useState('Esto un mensaje de prueba');
    const [alertType, setAlertType] = useState('success');

    //Gestion del Alert del Header
    const [showAlertHeader, setShowAlertHeader] = useState(false);
    const openAlertHeader = () => {
        setShowAlertHeader(true);
    };
    const closeAlertHeader = () => {
        setShowAlertHeader(false);
    };



    const [showNewPropertyModal, setShowNewPropertyModal] = useState(false);
    const openNewPropertyModal = () => {
        setShowNewPropertyModal(true);
    };

    const closeNewPropertyModal = () => {
        setShowNewPropertyModal(false);
    };
    
    return (
        <AdminPropertiesListContext.Provider value={{
            setMessage,
            setAlertType,
            openAlertHeader,
            closeAlertHeader,
            openNewPropertyModal,
            closeNewPropertyModal,
            showNewPropertyModal,
        }}>
            {children}
        </AdminPropertiesListContext.Provider>
    );
};

export const useAdminPropertiesListContext = () => {
    return useContext(AdminPropertiesListContext);
};
